export const mutationKeys = {
  withdraw: ['withdraw'],
};
